import { defineStore } from 'pinia';
import { getCategoryListTree, getCategoryListTreerestful } from '@/api/product';
import { getCounts } from '@/api/shoppingcart';
import { appInfo } from './appInfo';
import { userInfo } from './userInfo';

export const productInfo = defineStore('productInfo', {
  state: () => {
    return {
      categoryList: [], //获取到的全部分类树
      checkCategoryId: 0, //选择的一级分类
      categoryKeyValue: [], //铺平的全部分类树
      shoppingcartNum: 0, //购物车数量
      shopIconShake: false, //右侧购物车抖动
    };
  },
  getters: {
    checkCategoryList: state => {
      const index = state.categoryList.findIndex(item => item.id == state.checkCategoryId);
      if (index !== -1) {
        const chache = state.categoryList[index].children;
        chache.forEach(item => {
          if (item.children) {
            item.children.forEach(element => {
              if (element.children) {
                element.existStatus = element.children.some(item => item.existStatus == 1) ? 1 : 0;
              }
            });
          }
        });

        return chache;
      } else {
        return [{ children: [] }];
      }
    },
    mainCategory: state => {
      const chache = [];
      state.categoryKeyValue.forEach(item => {
        if (item.level == 1) {
          chache.push(item.name);
        }
      });
      return chache;
    },
  },
  actions: {
    async getCategoryList() {
      console.log('getCategoryList');
      const appStore = appInfo();
      const userStore = userInfo();
      const payLoad = appStore.isSmallCompanyHost ? { hostId: userStore.defaultHostId } : { hostId: 1 };
      await getCategoryListTreerestful(payLoad).then(res => {
        this.categoryList = res.data;
        this.checkCategoryId = res.data?.[0]?.id;
        this.categoryKeyValue = this.treeToArray(res.data);
      });
    },
    changeChecked(id) {
      this.checkCategoryId = id;
    },
    treeToArray(tree) {
      return tree.reduce((res, item) => {
        const { children, ...i } = item;
        return res.concat(i, children && children.length ? this.treeToArray(children) : []);
      }, []);
    },
    getCartNum() {
      getCounts().then(res => {
        this.shoppingcartNum = res.data;
      });
    },
    shakeShop() {
      setTimeout(() => {
        this.shopIconShake = true;
        setTimeout(() => {
          this.shopIconShake = false;
        }, 1000);
      }, 300);
    },
  },
});
